import React from 'react'

import { IMAGE_SIZES } from '@hozana/styling/image'

import { Cell } from 'elements/layout/Cell'
import { PreloadDiv } from 'elements/layout/PreloadDiv'
import { RoundDiv } from 'elements/layout/RoundDiv'
import { Row } from 'elements/layout/Row'
import { StretchCell } from 'elements/layout/StretchCell'

export type TPreloadUserInfoProps = { size?: keyof typeof IMAGE_SIZES.avatar }

export const PreloadUserInfo: TFC<TPreloadUserInfoProps> = ({ size = 'tiny' }) => (
  <Row h="100%" nowrap>
    <Cell m="0 10px 0 0" align="middleCenter">
      <PreloadDiv as={RoundDiv} size={IMAGE_SIZES.avatar[size].replace(/x\d+/, 'px')} />
    </Cell>
    <StretchCell m="0 5px 0 0">
      <PreloadDiv h="1em" w="100px" />
    </StretchCell>
  </Row>
)
